var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},[_c('span',{staticClass:"score-title"},[_vm._v("SCORE")]),_vm._v(" "),_c('div',{staticClass:"score-details"},[_c('span',[_vm._v(_vm._s(_vm.score))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98460a7c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/score.vue
// module id = null
// module chunks = 